import { Store } from "../../../flux/Store";
import { names } from "./ValueActions";

export interface ValueStoreState<T>
{
    value: T;
}

export class ValueStore<T> extends Store<ValueStoreState<T>>
{
    constructor()
    {
        super();
        this.state = { value: null };

        this.register<T>(names.SET, e => {
            if(e.meta === this.dispatchToken)
                return this.field({ value: e.payload });
        });
        this.register(names.CLEAR, e => {
            if(e.meta === this.dispatchToken)
                return this.field({ value: null });
        })
    }

    getValue = () => this.state.value;
}


// WEBPACK FOOTER //
// ./src/app/flux/Value/ValueStore.ts